module.exports = __webpack_public_path__ + "assets/bell-icon.5028aa00.svg";